import { Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/LaborExtra/LaborExtraModel';
import { RootState } from '../../../store';
import LaborExtraForm from '../LaborExtraForm/LaborExtraForm';

const LaborExtraModal: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxLaborExtra = useSelector((state: RootState) => state.models.laborExtra);

  return (
    <Modal
      title={!!reduxLaborExtra.id ? 'Modifica' : 'Adauga'}
      open={reduxLaborExtra.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <LaborExtraForm />
    </Modal>
  );
};

export default LaborExtraModal;
